module.exports = __webpack_public_path__ + "static/5-fcb6187200fc37b0a79472e6fc3a50f4.png";